<div
    #layerElement
    class="layer"
    aria-roledescription="button"
    (click)="selectLayerClicked(layer, layerElement.id)"
    [attr.id]="'layer-list-item-' + layer.nameOrDefault"
>
    <div class="layer-list-items-left">
        <ng-container *ngrxLet="layer.shaderColor?.value$ as color">
            <ng-container *ngIf="layer.type !== 'segmentation' && (layer.visible$ | async)">
                <div class="layer-color-indicator" [style.background-color]="color || null"></div>
            </ng-container>
            <ng-container *ngIf="layer.type !== 'segmentation' && !(layer.visible$ | async)">
                <div class="layer-color-indicator"></div>
            </ng-container>
        </ng-container>

        <div
            class="layer-name-container"
            [class.highlight]="layer.visible$ | async"
            [title]="layer.nameOrDefault"
        >
            <div class="layer-name">
                {{
                    isSelectionLayer(layer)
                        ? '&nbsp;'.repeat((layer.level - 1) * 3) +
                          (layer.level > 1 ? '\u21B3 ' : '')
                        : ''
                }}
                {{ layer.nameOrDefault }}
            </div>
        </div>
    </div>

    <div class="layer-list-items-right">
        <div class="layer-info">
            <span class="hover-value" *ngIf="layer.hoverLabel$ | async as label">
                {{ label }}
            </span>

            <button class="icon-button" (click)="toggleLayerVisibility($event, layer)">
                <ng-container *ngIf="layer.visible$ | async">
                    <cds-icon shape="eye"></cds-icon>
                </ng-container>
                <ng-container *ngIf="!(layer.visible$ | async)">
                    <cds-icon class="eye-hide" shape="eye-hide"></cds-icon>
                </ng-container>
            </button>
        </div>
    </div>
</div>
